import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import * as firebase from 'firebase';
import { Router } from '@angular/router';


const config = {
    apiKey: "AIzaSyCRqDgCdakS0wwdu77w3LJxDM24raFHDYI",
    authDomain: "chalax-work-log-fiat.firebaseapp.com",
    databaseURL: "https://chalax-work-log-fiat.firebaseio.com",
    projectId: "chalax-work-log-fiat",
    storageBucket: "chalax-work-log-fiat.appspot.com",
    messagingSenderId: "10740583063",
    appId: "1:10740583063:web:7a8ca1066ef91fd6"
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  public user = {};
  public fbAuth = null;
  
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'List',
      url: '/list',
      icon: 'list'
    }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private route:Router
  ) {
    this.initializeApp();
    this.fbAuth = firebase.auth();
    this.fbAuth.onAuthStateChanged(user=>{
     if(user==null){
      this.route.navigate(['/login']);
      
      // this.monitorChatValue();
     }else{
       this.user = user;
       this.user = user;
      // console.log(this.fbAuth.currentUser.uid);
      this.monitorChatValue(this.fbAuth.currentUser.uid);
     }
      
    });

    




    


  } 

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });

    firebase.initializeApp(config);
    this.requestNotificationCapability();
  }
  doLogout = function(){
    this.fbAuth.signOut();
    console.log("sign out");
    
  }

  requestNotificationCapability = function(){
    if(Notification.permission!=="granted"){
      Notification.requestPermission();
    }
  }

  monitorChatValue = function(myid){
    firebase.database().ref("chats").on("child_added",function(snapshot){
      
      var isi = snapshot.val();
      var currentTtimestamp = Date.now() - isi.timestamp;
      if(Notification.permission==="granted"){
        if(isi.senderid!==myid && currentTtimestamp < 300000){
          new Notification("Jurnal FH",{
            body:isi.message
          });
        }
        
      }
    });
  }
}
